<header class="topbar">
  @if (topbarTitle(); as topbarTitle) {
    <app-topbar-title class="topbar__title" [icon]="topbarTitle.icon" [label]="topbarTitle.label | transloco" />
  } @else {
    <span class="topbar__title"></span>
  }

  <app-topbar-actions
    class="topbar__action"
    [buttonIcon]="'icons/common/add_icon.svg'"
    [buttonLabel]="'nav.topbar.newOffer' | transloco"
    [buttonLoading]="offerStore.loading()"
    (buttonClick)="onCreateOffer()"
  />
</header>
